export default __webpack_public_path__ + "static/media/FKLOGO.7ef71727.svg";